import React, { forwardRef } from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';
import st from '../popovers.module.sass';

function HeadWearFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { control } = useFormContext();
  const { t } = useSearchPageTranslation();

  return (
    <FilterPopover
      {...props}
      name={['headwear_states', 'headwear_apparent_colors']}
      ref={ref}
    >
      <div className={st.Subtitle}>{t('filters.event_filters.body_attributes.head_wear')}</div>
      <div className={st.CheckboxContainer}>
        <ControllableOptionsFilter
          control={control}
          isSearchable={false}
          name="headwear_apparent_colors"
          options={EVENT_ENUMS.UPPER_BODY.HEADWEAR_COLORS.raw}
        />
      </div>
      <div className={st.Divider} />
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name="headwear_states"
        options={EVENT_ENUMS.UPPER_BODY.HEADWEAR.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const HeadWearFilterPopoverWithRef = forwardRef(HeadWearFilterPopover);
export { HeadWearFilterPopoverWithRef as HeadWearFilterPopover };
